import { capitalize, startsWith } from "lodash"
import { INSTRUMENTS } from "connected-components/dashboard/helpers"
import { DESC } from "helpers/sorts"

export type Metrics = (string | undefined | null)[]

export const EMPTY_ARRAY = []

function isValidMetric(metric: unknown): metric is string {
  return typeof metric === "string" && metric.length > 0
}

function normalizeMetric(metric: string, modelId: string): string {
  if (!startsWith(metric, "model")) {
    return metric
  }

  const [, metricModelId, ...values] = metric.split(".")
  if (metricModelId !== modelId) {
    return metric
  }

  return values.join(".")
}

export function getCurrentTemplateMetrics(metrics: Metrics, modelId: string) {
  return metrics
    .filter(isValidMetric)
    .map(metric => {
      return normalizeMetric(metric, modelId)
    })
}

export function resolveCustomDefaultSort(
  filteredMetrics: { id: string, downloadOnly?: boolean }[],
  instrumentColumns: string[],
) {
  const sortableMetrics = filteredMetrics.filter((metric) => !metric.downloadOnly)
  const primaryColumn = instrumentColumns[0] as keyof typeof INSTRUMENTS | undefined
  const defaultSortSuffix = primaryColumn != null ? (INSTRUMENTS[primaryColumn]?.suffix ?? "") : ""
  const marketValueSortPath = `marketValue${capitalize(defaultSortSuffix)}`
  const hasMarketValueColumn = sortableMetrics.some((metric) => metric.id === marketValueSortPath)
  const sortPath = hasMarketValueColumn ? marketValueSortPath : sortableMetrics[0]?.id

  return { path: sortPath ?? "label", direction: DESC }
}
